/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Csat_TitleInputs */

const en_us2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 1 to 5, how is the app working for you?`)
};

const pt_br2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 1 a 5, como está sendo usar o app?`)
};

const es_419_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Del 1 al 5, ¿cómo te está funcionando la app?`)
};

const pt_pt2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 1 a 5, como está a ser usar a app?`)
};

const fr_fr2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 1 à 5, comment se passe l'app pour toi ?`)
};

const de_de2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie gut funktioniert die App für dich, von 1 bis 5?`)
};

const it_it2_engagement_csat_title = /** @type {(inputs: Engagement_Csat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 1 a 5, come ti trovi con l'app?`)
};

/**
* | output |
* | --- |
* | "From 1 to 5, how is the app working for you?" |
*
* @param {Engagement_Csat_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_csat_title = /** @type {((inputs?: Engagement_Csat_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Csat_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_csat_title(inputs)
	if (locale === "es-419") return es_419_engagement_csat_title(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_csat_title(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_csat_title(inputs)
	if (locale === "de-DE") return de_de2_engagement_csat_title(inputs)
	if (locale === "it-IT") return it_it2_engagement_csat_title(inputs)
	return en_us2_engagement_csat_title(inputs)
});
export { engagement_csat_title as "engagement.csat_title" }